import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "wouter";

export default function Home() {
// Start and basic stuffs
const pause = async (ms) => {return new Promise((resolve) => setTimeout(resolve, ms))};
useEffect(() => {
    splashScreen();
}, [])

const [crackers, setCrackers] = useState(0)
const [crackerSkin, setCrackerSkin] = useState('cracker')

const [grand, setGrand] = useState(0);
const [grandPrice, setGrandPrice] = useState(5);
const [cat, setCat] = useState(0);
const [catPrice, setCatPrice] = useState(20);

async function splashScreen() {
    console.log('i was ran!')
    const tit1 = document.getElementById('titPart1')
    const tit2 = document.getElementById('titPart2')
    const flash = document.getElementById('flash')
    const titPic1 = document.getElementById('titPic1')
    const titPic2 = document.getElementById('titPic2')
    const butHolder = document.getElementById('butHolder')
    const titHolder = document.getElementById('titHolder')
    tit1.style.transform = 'translateX(100px)'
    await pause(500)
    tit2.style.transform = 'translateX(-100px)'
    await pause(2000)
    flash.style.display = 'block'
    butHolder.style.opacity = '1'
    titPic1.style.display = 'block'
    await pause(100)
    flash.style.opacity = '0'
    await pause(1000)
    flash.style.display = 'none'
}

async function bootGame() {
    const tit1 = document.getElementById('titPart1')
    const tit2 = document.getElementById('titPart2')
    const flash = document.getElementById('flash')
    const titPic1 = document.getElementById('titPic1')
    const titPic2 = document.getElementById('titPic2')
    const butHolder = document.getElementById('butHolder')
    const titHolder = document.getElementById('titHolder')
    const gameField = document.getElementById('gameField')
    flash.style.display = 'block'
    flash.style.opacity = '1'
    await pause(100)
    flash.style.opacity = '0'
    butHolder.style.display = 'none'
    titPic1.style.display = 'none'
    titPic2.style.display = 'block'
    await pause(100)
    tit1.style.transform = 'translateX(100%)'
    tit2.style.transform = 'translateX(-100%)'
    await pause(2000)
    titPic2.style.opacity = '0'
    await pause(1500)
    gameField.style.display = 'block'
    await pause(100)
    gameField.style.opacity = '1'
}

function click() {
    setCrackers(crackers + 1 + (grand * 0.1) + (cat * 1))
}

function buy(type) {
    if (type == 'cat') {
        if (crackers >= catPrice) {
            setCrackers(crackers - catPrice);
            setCatPrice(catPrice * 1.25);
            setCat(cat + 1);
        }
    } else if (type == 'grand') {
        if (crackers >= grandPrice) {
            setCrackers(crackers - grandPrice);
            setGrandPrice(grandPrice * 1.25);
            setGrand(grand + 1);
        }
    }
}



return (
    <>  
        <title>Grimm's Corner</title>
        <div className="main">
            <div className="introCont">
                <div className="flash" id="flash"></div>
                <div className="titHolder" id='titHolder'>
                <img src='images/cracker/cracker.png' id='titPic1'/>
                <img src='images/cracker/evilCracker.png' id='titPic2'/>
                <h1 className="titPart1" id='titPart1'>Cracker</h1>
                    <h1 className="titPart2" id='titPart2'>Clicker</h1>
                </div>
                <div className="butHolder" id="butHolder">
                    <button className="buttonS">See Project Page!</button>
                    <button className="buttonB" onClick={bootGame}>Play!</button>
                    <button className="buttonS">Check my website!</button>
                </div>
            </div>

            {/*  Game Shit  */}
            <div className="gameField" id="gameField">
                <div className="crackerField" id='crackerField'>
                    <h2>Crackers: {Math.round(crackers * 100) / 100}</h2>
                    <div style={{height:'300px', width:'100%', backgroundColor:'red', justifyContent:'center', alignItems:'center'}}>
                        <img src={`images/cracker/${crackerSkin}.png`} className="cracker" id='cracker' onClick={click}/>
                    </div>




                    <div className="buttonField">
                        <button>Save</button>
                        <button>Load</button>
                    </div>
                </div>

                <div className="buyingField">
                    <div className="upgradeBox" onClick={() => buy('grand')}>
                        <img src='images/upgrades/grandma.png'/>
                        <p>Grandmas</p>
                        <h6>{Math.round((grandPrice) * 100) / 100} Crackers</h6>
                        <h4>{Math.round((grand) * 100) / 100}</h4>
                    </div>

                    <div className="upgradeBox" onClick={() => buy('cat')}>
                        <img src='images/upgrades/cat.png'/>
                        <p>Cats</p>
                        <h6>{Math.round((catPrice) * 100) / 100} Crackers</h6>
                        <h4>{Math.round((cat) * 100) / 100}</h4>
                    </div>
                </div>
            </div>


            
        </div>
    </>
    );
}